import React from "react";

import "./LevelTestSummary.css";

// 레벨테스트 성적표 한 장. 점수·영역별 막대·남은 여정·지난 응시가 들어간다.
//
// **이 컴포넌트를 두 곳이 함께 쓴다.** 학생 자기 성적표(LevelTestSummary)와, 아직
// 한 번도 안 본 학생에게 흐리게 깔아 주는 예시(LevelTestInvite)다. 예시를 따로
// 그리면 진짜 카드와 크기·모양이 조금씩 어긋나고, 그러면 "이런 걸 받는다" 는 말이
// 믿기지 않는다. 같은 컴포넌트로 그려야 픽셀까지 같다.
//
// `goSlot` 은 점수 줄 오른쪽에 들어갈 것이다. 리포트 보기, 이번 호 응시하기가
// 여기로 들어온다. 카드 자체는 링크를 모른다.
//
// **점수 줄 전체를 링크로 감싸지 않는다.** 예전에는 `<a>` 로 감싸고 그 안에 또
// 링크를 넣었는데, 안쪽을 눌러도 바깥 링크가 먼저 잡혀 이동이 안 됐다. 누를 수
// 있는 것은 goSlot 안의 링크뿐이다.
const LevelTestReportCard = ({ latest, results = [], journey = [], goSlot }) => (
  <section className="level-test-summary">
    <div className="level-test-summary__header">
      <div className="level-test-summary__title">레벨테스트</div>
      {latest && (
        <div className="level-test-summary__month">
          {latest.taken_month.replace("-", ". ")} 응시
        </div>
      )}
    </div>

    {latest ? (
      <div className="level-test-summary__latest">
        <div className="level-test-summary__score">
          <span className="level-test-summary__score-number">
            {latest.score_percent}
          </span>
          <span className="level-test-summary__score-unit">점</span>
        </div>
        <div className="level-test-summary__latest-detail">
          <div className="level-test-summary__stage">
            STAGE {String(latest.stage).padStart(2, "0")} {latest.stage_name}
          </div>
          <div className="level-test-summary__count">
            {latest.right_count} / {latest.total_count} 문항 정답
          </div>
        </div>
        {goSlot}
      </div>
    ) : (
      <p className="level-test-summary__empty-text">
        채점이 끝나면 점수가 여기에 표시돼요.
      </p>
    )}

    {latest && latest.areas.length > 0 && (
      <div className="level-test-summary__areas">
        {latest.areas.map((area) => (
          <div key={area.area} className="level-test-summary__area">
            <span className="level-test-summary__area-name">{area.area}</span>
            <span className="level-test-summary__area-bar">
              {/* 막대 길이는 실제 점수라 런타임 값이다. 인라인으로 둘 수밖에 없다. */}
              <i style={{ width: `${area.pct}%` }} />
            </span>
            <span className="level-test-summary__area-value">{area.pct}%</span>
          </div>
        ))}
      </div>
    )}

    {journey.length > 0 && (
      <div className="level-test-summary__journey">
        <div className="level-test-summary__journey-title">수능까지 남은 여정</div>
        <div className="level-test-summary__journey-grid">
          {journey.map((card) => {
            // 실측이 없는 카드는 레벨 체크로 가는 문이 된다. '준비 중' 이라고만 두면
            // 학생은 무엇을 해야 그 숫자가 나오는지 알 수 없다.
            const isCheckable = card.state === "pending" && card.check_url;
            const CardTag = isCheckable ? "a" : "div";

            return (
              <CardTag
                key={card.label}
                className={`journey-card${isCheckable ? " journey-card--checkable" : ""}`}
                title={card.note}
                {...(isCheckable
                  ? { href: card.check_url, target: "_blank", rel: "noreferrer" }
                  : {})}
              >
                <div className="journey-card__label">{card.label}</div>
                {card.state === "estimated" && (
                  <>
                    <div className="journey-card__months">
                      <b>{card.months}</b>개월
                    </div>
                    <div className="journey-card__target">
                      {card.target_year}년 {card.target_month}월
                    </div>
                  </>
                )}
                {card.state === "complete" && (
                  <div className="journey-card__months journey-card__months--done">
                    완주 🎓
                  </div>
                )}
                {card.state === "pending" && (
                  <div className="journey-card__pending">
                    {isCheckable ? "레벨 체크하기 ›" : "준비 중"}
                  </div>
                )}
              </CardTag>
            );
          })}
        </div>
      </div>
    )}

    <ul className="level-test-summary__history">
      {results.map((result) => (
        <li key={result.session_id} className="level-test-summary__history-item">
          <span className="level-test-summary__history-month">
            {result.taken_month.replace("-", ". ")}
          </span>
          <span className="level-test-summary__history-stage">
            STAGE {String(result.stage).padStart(2, "0")}
          </span>
          <span className="level-test-summary__history-score">
            {result.is_finished ? `${result.score_percent}점` : "진행중"}
          </span>
        </li>
      ))}
    </ul>
  </section>
);

export default LevelTestReportCard;
